/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Marketplace, MarketplaceInterface } from "../Marketplace";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "assetsContract",
        type: "address",
      },
      {
        internalType: "address",
        name: "equipmentContract",
        type: "address",
      },
      {
        internalType: "address",
        name: "wrapperFactoryContract",
        type: "address",
      },
      {
        internalType: "address",
        name: "uniswapFactoryContract",
        type: "address",
      },
      {
        internalType: "address",
        name: "uniswapRouterContract",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "ptgID",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "itemID",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "prestigeAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenAmount",
        type: "uint256",
      },
    ],
    name: "Bootstrap",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "itemID",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "prestigeAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenAmount",
        type: "uint256",
      },
    ],
    name: "Buy",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "itemID",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "quantity",
        type: "uint256",
      },
    ],
    name: "Mint",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "itemID",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "prestigeAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenAmount",
        type: "uint256",
      },
    ],
    name: "Sell",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "itemID",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "quantity",
        type: "uint256",
      },
    ],
    name: "prices",
    outputs: [
      {
        internalType: "uint256",
        name: "buy",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "sell",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "itemID",
        type: "uint256",
      },
    ],
    name: "reserves",
    outputs: [
      {
        internalType: "uint256",
        name: "ptg",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "item",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "uniswapFactory",
    outputs: [
      {
        internalType: "contract IUniswapV2Factory",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "uniswapRouter",
    outputs: [
      {
        internalType: "contract IUniswapV2Router02",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "wrappedPTG",
    outputs: [
      {
        internalType: "contract IAssetsERC20Wrapper",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "itemID",
        type: "uint256",
      },
    ],
    name: "wrapper",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

export class Marketplace__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    assetsContract: string,
    equipmentContract: string,
    wrapperFactoryContract: string,
    uniswapFactoryContract: string,
    uniswapRouterContract: string,
    ptgID: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Marketplace> {
    return super.deploy(
      assetsContract,
      equipmentContract,
      wrapperFactoryContract,
      uniswapFactoryContract,
      uniswapRouterContract,
      ptgID,
      overrides || {}
    ) as Promise<Marketplace>;
  }
  getDeployTransaction(
    assetsContract: string,
    equipmentContract: string,
    wrapperFactoryContract: string,
    uniswapFactoryContract: string,
    uniswapRouterContract: string,
    ptgID: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      assetsContract,
      equipmentContract,
      wrapperFactoryContract,
      uniswapFactoryContract,
      uniswapRouterContract,
      ptgID,
      overrides || {}
    );
  }
  attach(address: string): Marketplace {
    return super.attach(address) as Marketplace;
  }
  connect(signer: Signer): Marketplace__factory {
    return super.connect(signer) as Marketplace__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MarketplaceInterface {
    return new utils.Interface(_abi) as MarketplaceInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Marketplace {
    return new Contract(address, _abi, signerOrProvider) as Marketplace;
  }
}
